import { useState } from "react";
import { Button } from "@provenleap/ui";
import { Copy, Check } from "@phosphor-icons/react";
import type { ToastType } from "../../hooks/useToast";

interface MCPServerCardProps {
  url: string;
  showToast: (type: ToastType, message: string) => void;
}

export function MCPServerCard({ url, showToast }: MCPServerCardProps) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      showToast("success", "URL copied to clipboard");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      showToast("error", "Couldn't copy URL — please copy manually");
    }
  }

  return (
    <div
      className="rounded-[22px] bg-background p-6 shadow-xs"
      style={{ border: "0.5px solid var(--hairline)" }}
    >
      <label
        htmlFor="mcp-server-url"
        className="text-[13px] font-medium block mb-2"
      >
        MCP Server URL
      </label>
      <div className="flex gap-2">
        <input
          id="mcp-server-url"
          type="text"
          readOnly
          value={url}
          onFocus={(e) => e.currentTarget.select()}
          className="flex-1 px-3 py-2 rounded-2xl text-[13px] font-mono bg-muted/40 shadow-xs text-foreground placeholder:text-foreground"
          style={{ border: "0.5px solid var(--hairline)" }}
          data-testid="mcp-server-url-input"
        />
        <Button
          variant="brand"
          className="rounded-2xl text-[13px] cursor-pointer"
          onClick={handleCopy}
          data-testid="copy-mcp-url"
          aria-label="Copy MCP Server URL"
        >
          {copied ? (
            <>
              <Check size={14} className="mr-1" />
              Copied
            </>
          ) : (
            <>
              <Copy size={14} className="mr-1" />
              Copy
            </>
          )}
        </Button>
      </div>
      <p className="mt-2 text-[12px] text-foreground">
        This is your unique connection URL. You'll authenticate with your
        ProvenLeap account when you connect.
      </p>
    </div>
  );
}
